module.exports = __webpack_public_path__ + "static/media/zwyy.12c8624.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/images/zwyy.mp4
// module id = 3glr
// module chunks = 1